import { CancelToken } from 'axios'

import { handleAxiosError } from '../helpers'
import { instance } from '../helpers'

export const cityServices = {
  get,
}

function get(cancel) {
  return instance
    .get('/cities', { cancelToken: new CancelToken(c => (cancel.exec = c)) })
    .then(response => {
      return response
    })
    .catch(error => {
      return handleAxiosError(error)
    })
}
